import { render } from "./SingleThought.vue?vue&type=template&id=5a147c98&scoped=true&ts=true"
import script from "./SingleThought.vue?vue&type=script&lang=ts"
export * from "./SingleThought.vue?vue&type=script&lang=ts"

import "./SingleThought.vue?vue&type=style&index=0&id=5a147c98&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a147c98"]])

export default __exports__